import { createSelector } from '@reduxjs/toolkit';
import { selectBeds } from 'shared/selectors/jsonQuery';
import { MAX_VALUE, MIN_VALUE } from './constants';

export const selectBedsValue = createSelector(selectBeds, beds => {
  const { gte } = beds || {};

  return gte ? Math.max(MIN_VALUE, Math.min(MAX_VALUE, gte)) : MIN_VALUE;
});
